import React from 'react';
import { Award } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TIER_STYLES = {
  bronze:   { bg: 'bg-orange-100', text: 'text-orange-700', ring: 'ring-orange-200', label: 'Bronze' },
  silver:   { bg: 'bg-gray-200',   text: 'text-gray-700',   ring: 'ring-gray-300',   label: 'Silver' },
  gold:     { bg: 'bg-yellow-100', text: 'text-yellow-700', ring: 'ring-yellow-200', label: 'Gold' },
  platinum: { bg: 'bg-purple-100', text: 'text-purple-700', ring: 'ring-purple-200', label: 'Platinum' },
};

const TierBadge = ({ tier = 'bronze', size = 'md', showLabel = true, tooltip, className = '' }) => {
  const { t } = useTranslation('customers');
  const style = TIER_STYLES[tier] || TIER_STYLES.bronze;
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5 gap-1' : 'text-xs px-2.5 py-1 gap-1.5';
  const iconSize = size === 'sm' ? 'h-2.5 w-2.5' : 'h-3 w-3';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ring-1 ${sizeClass} ${style.bg} ${style.text} ${style.ring} ${className}`}
      title={tooltip}
    >
      <Award className={iconSize} />
      {showLabel && <span className="capitalize">{t(`tier.${tier}`)}</span>}
    </span>
  );
};

export default TierBadge;
